import { ALL_TRANSACTION_SOURCES, TransactionSource, TransactionType } from "@goodfill/domain-properties";
import { Flex, InputDate } from "@goodfill/ui-components";
import { DateTime } from "luxon";
import { FilterSimpleSelectBox } from "../../../../../filters/FilterSimpleSelectBox";
import { FieldGroup } from "../../../../../form/FieldGroup";
import { PortfolioDepositHistoryFilter } from "./PortfolioDepositHistoryFilter";

const DEPOSIT_AND_WITHDRAWAL_TYPES = [TransactionType.Deposit, TransactionType.Withdrawal];

export const PortfolioDepositHistoryFilterComponent = ({
  constraints: criteria,
  onConstraintsChange,
}: {
  constraints: PortfolioDepositHistoryFilter;
  onConstraintsChange: (constraints: PortfolioDepositHistoryFilter) => void;
}) => {
  const onFilterChange = <T extends keyof PortfolioDepositHistoryFilter>(
    key: T,
    value: PortfolioDepositHistoryFilter[T],
  ) => onConstraintsChange({ ...criteria, [key]: value });

  return (
    <Flex direction="row">
      <Flex direction="col">
        <FieldGroup label={"Transaction Date"} validation={[]}>
          <Flex direction="row">
            <InputDate
              value={criteria.transactedAtSince?.toFormat("yyyy-MM-dd") ?? ""}
              setValue={(value) => {
                onFilterChange("transactedAtSince", value === "" ? null : DateTime.fromISO(`${value}T00:00:00`));
              }}
            />
            <InputDate
              value={criteria.transactedAtTill?.toFormat("yyyy-MM-dd") ?? ""}
              setValue={(value) => {
                onFilterChange("transactedAtTill", value === "" ? null : DateTime.fromISO(`${value}T00:00:00`));
              }}
            />
          </Flex>
        </FieldGroup>
      </Flex>
      <Flex direction="col">
        <FieldGroup label={"Type"} validation={[]}>
          <FilterSimpleSelectBox
            options={DEPOSIT_AND_WITHDRAWAL_TYPES}
            value={`${criteria.type}`}
            onChange={(value) => onFilterChange("type", value !== null ? (value as TransactionType) : null)}
          />
        </FieldGroup>
        <FieldGroup label={"Source"} validation={[]}>
          <FilterSimpleSelectBox
            options={ALL_TRANSACTION_SOURCES}
            value={`${criteria.source}`}
            onChange={(value) => onFilterChange("source", value !== null ? (value as TransactionSource) : null)}
          />
        </FieldGroup>
      </Flex>
    </Flex>
  );
};
